import { FC } from "react";
import { Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useComponentAccess, useLoggedinUser, useTeamMembers } from "lib/hooks";
import { PermissionLevels } from "lib/types";
import { TeamUser } from "lib/types";

type Props = {
  onDelete: () => void;
  member: TeamUser;
}

export const TeamUserListingItemMenu: FC<Props> = ({ member, onDelete }) => {
  const { data: me } = useLoggedinUser();
  const { hasAccess } = useComponentAccess([PermissionLevels.ADMIN, PermissionLevels.OWNER]);
  const { updateTeamMember } = useTeamMembers();

  const canEdit = hasAccess && me.id !== member.user.id && member.permissions !== PermissionLevels.OWNER

  if (!canEdit) {
    return <Button isDisabled={true} width={100} size="sm">{member.permissions}</Button>
  }

  const handleUpdate = async (permissions: PermissionLevels.ADMIN | PermissionLevels.MEMBER) => {
    if (permissions === member.permissions) return;

    await updateTeamMember(member.user.id, permissions);
  }

  return (
    <Menu>
      <MenuButton variant="secondary" as={Button} rightIcon={<ChevronDownIcon />} width={100} size="sm">
        {member.permissions}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleUpdate(PermissionLevels.ADMIN)}>Admin</MenuItem>
        <MenuItem onClick={() => handleUpdate(PermissionLevels.MEMBER)}>Member</MenuItem>
        <MenuItem onClick={onDelete} color="error.500">Delete from team</MenuItem>
      </MenuList>
    </Menu>
  );
}
